export const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !("MSStream" in window);

export const isAndroid = /android/i.test(navigator.userAgent);
export const isPc = !(isIOS || isAndroid) && screen.width > 1000;
